import { useQuery } from "@tanstack/react-query";
import { BUYER_QUERY_KEY, buyerQueryApi } from "@/shared/api/buyer/query";
import { BuyerResponse } from "@/shared/api/buyer/types";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import { toCamelKeyObject } from "@/utils/case";

// 바이어 상세 조회 훅 — 바이어 페이지에서는 companyId가 buyer_id다.
// 세금계산서 발행 이메일처럼 사업자등록증과 별개로 저장되는 값을 여기서 읽는다.
// 비suspense 쿼리로 두어 호출하는 카드가 자체 로딩만 처리하고 페이지는 멈추지 않게 한다.
const useGetBuyer = () => {
  const { companyId } = useCompanyIdentity();

  const {
    data: buyer,
    isPending,
    refetch,
  } = useQuery({
    queryKey: BUYER_QUERY_KEY(companyId),
    queryFn: () => buyerQueryApi.getBuyer(companyId as number),
    select: (data) => toCamelKeyObject(data) as BuyerResponse,
    enabled: Boolean(companyId),
  });

  return { buyer, isPending, refetch };
};

export default useGetBuyer;
